export const MODULE_NAME = `rolesForm`
export const FORM_NAME = MODULE_NAME

// Заменяем точки на тире, потому, что redux-form считает точки вложенностью
const dotsToDashes = string => string.replace(/\./g, `-`)
const dashesToDots = string => string.replace(/-/g, `.`)

export const permissionListToFormState = (allPermissions, rolePermissions) =>
  allPermissions.reduce(
    (reduction, permission) => ({
      ...reduction,
      [dotsToDashes(permission.key)]: rolePermissions.some(
        rolePermission => rolePermission.key === permission.key,
      ),
    }),
    {},
  )

export const formStateToPermissionKeys = formState =>
  Object.keys(formState)
    .filter(key => formState[key])
    .map(dashesToDots)

export const addModulePrefix = constantString =>
  `${MODULE_NAME}/${constantString}`
